<template>
    <v-dialog v-model="showDialog"
              class="habit-delete-dialog"
              min-width="300"
              transition="dialog-bottom-transition"
              width="auto">
        <v-card class="date-time-form text-primary ma-0">
            <v-card-title>
                {{ habit ? 'Редактирование привычки' : 'Создание привычки' }}
            </v-card-title>

            <v-card-text class="pa-4 py-0">
                <v-text-field class="mt-0 mb-1"
                              label="Привычка"
                              v-model="habitName" />

                <v-date-picker v-model="startDate"
                               show-adjacent-months
                               title="Выберите дату начала формирования привычки"
                               class="text-primary"
                               color="primary" />
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn color="secondary"
                       variant="elevated"
                       @click="$emit('hide')">Отменить</v-btn>
                <v-btn color="primary"
                       variant="elevated"
                       :disabled="!startDate || !habitName"
                       @click="tryToSave">Сохранить</v-btn>
            </v-card-actions>
        </v-card>

        <habit-change-date-confirm-dialog v-if="confirmSave" :date="startDate" @save="save" @hide="confirmSave = false"></habit-change-date-confirm-dialog>
    </v-dialog>
</template>

<script>
    import HabitChangeDateConfirmDialog from "@/components/client/habits/HabitChangeDateConfirmDialog.vue";

    export default {
        components: {
            HabitChangeDateConfirmDialog
        },

        props: {
            minDate: Object,
            maxDate: Object,
            habit: Object
        },

        emits: ["create:habit", "hide"],

        data() {
            return {
                showDialog: true,

                id: 0,
                habitName: "",
                startDate: this.$store.state.currentDateTime ?? "",
                endDate: "",
                startDayIndex: 0,
                doneDaysCount: 0,
                isCompleted: false,
                days: [],
                confirmSave: false
            };
        },

        created() {
            if (this.habit) {
                this.habitName = this.habit.name;
                this.startDate = this.habit.startDate;
            }
        },

        computed: {
            currentDateTime() {
                return this.$store.state.currentDateTime;
            }
        },

        watch: {
            showDialog(newValue) {
                if (newValue === false) {
                    this.$emit("hide");
                }
            }
        },

        methods: {
            createDays(daysCount) {
                const weekday = this.startDate.weekday;

                this.startDayIndex = weekday - 1;

                const firstDate = this.startDate.minus({ days: weekday - 1 });

                const days = [];

                for (let i = 0; i < daysCount; i++) {
                    const date = firstDate.plus({ days: i });

                    days.push({
                        id: 0,
                        index: i,
                        number: 0,
                        date: date,
                        isDone: null
                    });

                    this.endDate = date;
                }

                return days;
            },

            save() {
                if (!this.startDate || !this.habitName) {
                    return;
                }

                const days = this.createDays(42);

                const newHabit = {
                    id: this.id,
                    name: this.habitName,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    startDayIndex: this.startDayIndex,
                    doneDaysCount: this.doneDaysCount,
                    isCompleted: this.isCompleted,
                    days: days
                };

                this.$emit("hide");
                this.$emit("create:habit", newHabit);
                this.confirmSave = false;
            },

            tryToSave() {
                if (this.habit !== undefined && this.habit.days.some(d => d.date < this.startDate && d.isDone != null)) {
                    this.confirmSave = true;
                } else {
                    this.save();
                }
            }
        }
    };
</script>